import {
  Collapse,
  Tabs,
  message,
  Table,
  Form,
  Input,
  Button,
  Row,
  Col,
} from "antd";
import { useEffect, useState } from "react";
const { Panel } = Collapse;
import CreditReviewForm from "@/components/CreditReviewForm";
import Approvalform from "@/components/tabApproval";
import PhotoDocumentTab from "@/components/PhotoDocumentTab";
import ThumbnailGrid from "@/components/ThumbnailGrid";
import { useSearchParams } from "react-router-dom";
import { useParams } from "react-router-dom";
import useRoleAccess from "@/hooks/useRoleAccess";
import DetailKendaraan from "./DetailKendaraan";
import InputPerhitunganKredit from "./InputPerhitunganKredit";

const namacmo = localStorage.getItem("namanya");
const cabangmana = localStorage.getItem("cabangnya");

console.log("INI NAMA CMO NYA", namacmo);

const ApprovalDetailPage = () => {
  const { isViewer } = useRoleAccess();
  const [nikPasangan, setNikPasangan] = useState(null);
  const [data, setData] = useState([]);
  const [pemohonData, setPemohonData] = useState({});
  const [headerInfo, setHeaderInfo] = useState({});
  const [status, setStatus] = useState("-");
  const { application_id, nik } = useParams();
  const [dokumenUrls, setDokumenUrls] = useState({
    uri_slik: null,
    uri_slik_pasangan: null,
    summary_slik: null,
    summary_slik_pasangan: null,
    uri_pefindo: null,
    uri_pefindo_pasangan: null,
  });

  const API_BASE_URL2 = import.meta.env.VITE_BASE_URL2; //3001
  const API_BASE_URL = import.meta.env.VITE_BASE_URL; //3000

  const checkAndSetStatus = (result) => {
    let newStatus = "Credit Review";
    if (result.credit_review && Object.keys(result.credit_review).length > 0)
      newStatus = "Approval 1";
    if (result.approval1 && Object.keys(result.approval1).length > 0)
      newStatus = "Approval 2";
    if (result.approval2 && Object.keys(result.approval2).length > 0)
      newStatus = "Approval 3";
    if (result.approval3 && Object.keys(result.approval3).length > 0)
      newStatus = "Final Approved";
    setStatus(newStatus);
  };

  const getData = async () => {
    try {
      const API_BASE_URL2 = import.meta.env.VITE_BASE_URL2; //3001
      const API_BASE_URL = import.meta.env.VITE_BASE_URL; //3000

      const response = await fetch(
        `${API_BASE_URL2}/api/alldata/${application_id}/${nik}`,
      );
      const result = await response.json();

      const resDataPemohon = await fetch(
        `${API_BASE_URL}/api/pemohon/getdetailpemohon/${application_id}/${nik}`,
      );
      const dataPemohon = await resDataPemohon.json();

      const photoRes = await fetch(
        `${API_BASE_URL2}/api/foto-dokumen/searchby/${application_id}/${nik}`,
      );
      const photoDocs = await photoRes.json();

      const fotoTambahanRes = await fetch(
        `${API_BASE_URL2}/api/foto-tambahan/searchby/${application_id}/${nik}`,
      );
      const fotoTambahan = await fotoTambahanRes.json();

      setNikPasangan((result.pasangan_pemohon || {}).ktppasangan || null);

      console.log("result API ==> ", result);

      const dealer = result.dealer || {};
      const pemohon = result.pemohon || {};
      const pekerjaan = result.pekerjaan_pemohon || {};
      const pasangan = result.pasangan_pemohon || {};
      const pekerjaan_pasangan = result.pekerjaan_pasangan || {};
      const penjamin = result.penjamin || {};
      const pekerjaan_penjamin = result.pekerjaan_penjamin || {};
      const pasangan_penjamin = result.pasangan_penjamin || {};
      const pekerjaan_pasangan_penjamin =
        result.pekerjaan_pasangan_penjamin || {};
      const kontak_darurat = result.kontak_darurat || {};
      const perhitaungan_kredit = result.perhitaungan_kredit || {};
      const { 
        uri_slik, 
        uri_slik_pasangan, 
        summary_slik, 
        summary_slik_pasangan, 
        uri_pefindo, 
        uri_pefindo_pasangan,
        jeniskelamin,
      } = dataPemohon;

      const jenisKelaminPemohon =
        String(jeniskelamin) === "1"
          ? "Laki-laki"
          : String(jeniskelamin) === "2"
            ? "Perempuan"
            : null;
      const jenisKelaminPasangan =
        String(jeniskelamin) === "1"
          ? "Perempuan"
          : String(jeniskelamin) === "2"
            ? "Laki-laki"
            : null;

      setPemohonData({
        nama: pemohon.nama,
        noKtp: pemohon.nik,
        jenisKelamin: jenisKelaminPemohon,
        alamat: pemohon.alamat,
        agama: pemohon.agamapemohon,
        pendidikan: pemohon.pendidikan,
        jenisPekerjaan: pemohon.jenispekerjaan,
        wargaNegara: pemohon.warganegarapemohon,
        nomorTelepon: pemohon.nomortelepon,
        noHp: pemohon.nohp,
      });

      // Rewrite URL dokumen dari HTTP/IP ke domain HTTPS agar tidak diblokir
      // oleh browser (Mixed Content) saat web berjalan di server HTTPS.
      // Port 3000 (VITE_BASE_URL) -> https://api1.gratama-finance.com
      const toSecureDocUrl = (url) => {
        if (!url || typeof url !== "string") return url;
        return url.replace(/^http:\/\/217\.196\.49\.162:3000/, API_BASE_URL);
      };

      // Memasukkan semuanya ke dalam 1 state
      setDokumenUrls({
        uri_slik: toSecureDocUrl(uri_slik),
        uri_slik_pasangan: toSecureDocUrl(uri_slik_pasangan),
        summary_slik: toSecureDocUrl(summary_slik),
        summary_slik_pasangan: toSecureDocUrl(summary_slik_pasangan),
        uri_pefindo: toSecureDocUrl(uri_pefindo),
        uri_pefindo_pasangan: toSecureDocUrl(uri_pefindo_pasangan),
      });

      const labelMap = {
        fotounitdepan: "Foto Unit Depan",
        fotounitbelakang: "Foto Unit Belakang",
        fotounitinteriordepan: "Interior Depan",
        fotounitmesinplat: "Foto Mesin & Plat",
        fotomesin: "Foto Mesin",
        fotobpkb1: "BPKB Halaman 1",
        fotobpkb2: "BPKB Halaman 2",
        fotostnk: "STNK",
        fotonoticepajak: "Notice Pajak",
        fotoktppemohon: "KTP Pemohon",
        fotoktppasangan: "KTP Pasangan",
        fotokk: "Kartu Keluarga",
        fotosima: "SIM A",
        fotonpwp: "NPWP",
        fotorumah: "Foto Rumah",
        fotopemohonttdfpp: "TTD Pemohon di FPP",
        fotofppdepan: "FPP Depan",
        fotofppbelakang: "FPP Belakang",
        fotounitselfiecmo: "Selfie CMO + Unit",
        fotospeedometer: "Speedometer",
        fotogesekannoka: "Gesekan Noka",
        fotocloseuppemohon: "Closeup Pemohon",
        fotobuktimilikrumah: "Bukti Kepemilikan Rumah",
        fotorumahselfiecmo: "Rumah + Selfie CMO",
        fotolingkunganselfiecmo: "Lingkungan + Selfie CMO",
      };

      console.log("INI RESULT PEMOHON", result.pemohon);

      setHeaderInfo({
        application_no: result.pemohon?.application_id || "-",
        customer_name: result.pemohon?.nama || "-",
        application_date: result.pemohon?.created_date?.split("T")[0] || "-",
        status: result.pemohon?.status || "-",
        branch_name: result.pemohon?.cabang || "-",
        // branch_name: cabangmana || "-",
        cmo: result.pemohon?.cmofullname || "-",
        created_date: result.pemohon?.created_date || "-",
        status: result.pemohon?.status || "-",
      });

      checkAndSetStatus(result);
      const hiddenFields = [
        "id",
        "application_id",
        "nik",
        "created_by",
        "updated_by",
        "created_date",
        "updated_date",
      ];
      const API_IMAGE_BASE = "https://api2.gratama-finance.com";

      const photoSection = [
        {
          panel: "Foto Utama",
          items: Object.entries(photoDocs || {})
            .filter(
              ([key, value]) =>
                !hiddenFields.includes(key) &&
                typeof value === "string" &&
                value.startsWith("http"),
            )
            .map(([key, url]) => ({
              label: labelMap[key] || key,
              value: url?.replace("http://217.196.49.162:3001", API_IMAGE_BASE),
            })),
        },
      ];

      const formatFotoTambahan = (label, urls, type) => {
        let parsedUrls = [];
        if (Array.isArray(urls)) {
          parsedUrls = urls;
        } else if (typeof urls === "string") {
          try {
            parsedUrls = JSON.parse(urls);
          } catch (e) {
            console.warn(
              `⚠️ formatFotoTambahan: Gagal parse urls untuk ${label}:`,
              urls,
            );
            parsedUrls = [];
          }
        } else if (!urls) {
          parsedUrls = [];
        }

        const files = parsedUrls.map((url, index) => ({
          label: `${label} ${index + 1}`,
          value: url ? `${API_IMAGE_BASE}${new URL(url).pathname}` : null,
        }));

        return files;
      };

      const additionalPhotoAlbums = [];
      if (fotoTambahan.docpekerjaanimage?.length !== undefined)
        additionalPhotoAlbums.push({
          panel: "Foto & Dokumen Pekerjaan",
          items: formatFotoTambahan(
            "Dok Pekerjaan",
            fotoTambahan.docpekerjaanimage,
            "docpekerjaanimage",
          ),
        });

      if (fotoTambahan.docsimulasiimage?.length && !isViewer)
        additionalPhotoAlbums.push({
          panel: "Foto & Dokumen Simulasi",
          items: formatFotoTambahan("Simulasi", fotoTambahan.docsimulasiimage),
        });
      if (fotoTambahan.doctambahanimage?.length && !isViewer)
        additionalPhotoAlbums.push({
          panel: "Foto & Dokumen Tambahan",
          items: formatFotoTambahan("Tambahan", fotoTambahan.doctambahanimage),
        });

      const combinedPhotos = [...photoSection, ...additionalPhotoAlbums];

      const rawCustomerData = {
        dealer: [
          { label: "Kode Dealer", value: dealer.kddealer },
          { label: "Nama Dealer", value: dealer.namadealer },
          { label: "Alamat Dealer", value: dealer.alamatdealer },
          { label: "Telpon Dealer", value: dealer.telpondealer },
          { label: "Nama Pemilik Dealer", value: dealer.namapemilikdealer },
          { label: "Nomor Hp Pemilik Dealer", value: dealer.nohppemilik },
          { label: "PIC Dealer", value: dealer.picdealer },
        ],
        kendaraan: [
          { label: "Kondisi kendaraan", value: dealer.kondisikendaraan },
          { label: "Merk Kendaraan", value: dealer.merkkendaraan },
          { label: "Nama Dealer", value: dealer.namadealer },
          { label: "Tipe Kendaraan", value: dealer.typekendaraan },
          { label: "Tahun Kendaraan", value: dealer.tahunkendaraan },
          { label: "No Polisi Kendaraan", value: dealer.nopolisikendaraan },
          { label: "Harga Kendaraan", value: dealer.hargakendaraan },
          { label: "Uang Muka", value: dealer.uangmuka },
          { label: "Pokok Hutang", value: dealer.pokokhutang },
        ],
        customer: [
          { label: "Kategori Pemohon", value: pemohon.katpemohon },
          { label: "Status Pernikahan", value: pemohon.statuspernikahan },
          { label: "Nama", value: pemohon.nama },
          { label: "Alamat Pemohon ", value: pemohon.alamat },
          { label: "Nomor KTP", value: pemohon.nik },
          { label: "Jenis Kelamin", value: jenisKelaminPemohon },
          { label: "Agama Pemohon", value: pemohon.agamapemohon },
          { label: "Pendidikan", value: pemohon.pendidikan },
          { label: "Jenis Pekerjaan", value: pemohon.jenispekerjaan },
          { label: "Warga Negara", value: pemohon.warganegarapemohon },
          { label: "Nomor Telepon", value: pemohon.nomortelepon },
          { label: "No HP", value: pemohon.nohp },
          { label: "Email", value: pemohon.email },
          { label: "SIM", value: pemohon.sim },
          { label: "NPWP", value: pemohon.npwp },
          { label: "Nama Ibu", value: pemohon.namaibu },
          { label: "Status Rumah", value: pemohon.statusrumah },
          { label: "Lokasi Rumah", value: pemohon.lokasirumah },
          { label: "Kategori Rumah Pemohon", value: pemohon.katrumahpemohon },
          {
            label: "Bukti Milik Rumah Pemohon",
            value: pemohon.buktimilikrumahpemohon,
          },
          { label: "Lama Tinggal Pemohon", value: pemohon.lamatinggalpemohon },
        ],
        // ... (sisa mapping tetap sama seperti sebelumnya)
        pekerjaan_pemohon: [
          { label: "Nama Perusahaan", value: pekerjaan.namaperusahaan },
          { label: "Kode Pos Perusahaan", value: pekerjaan.kodeposperusahaan },
          { label: "Alamat Usaha", value: pekerjaan.alamatusaha },
          { label: "Jabatan", value: pekerjaan.jabatan },
          { label: "Keterangan Jabatan", value: pekerjaan.ketjabatan },
          { label: "No. Telepon Usaha/Kantor", value: pekerjaan.noteleponusaha },
          { label: "Masa Kerja Pemohon", value: pekerjaan.masakerjapemohon },
          { label: "Gaji Pemohon", value: pekerjaan.gajipemohon },
          { label: "Slip Gaji Pemohon", value: pekerjaan.slipgajipemohon },
          { label: "Payroll Pemohon", value: pekerjaan.payrollpemohon },
          {
            label: "Nama Perusahaan (Usaha)",
            value: pekerjaan.usaha_namaperusahaan,
          },
          {
            label: "Bidang Usaha Pemohon",
            value: pekerjaan.bidangusahapemohon,
          },
          { label: "Lama Usaha Pemohon", value: pekerjaan.lamausahapemohon },
          { label: "Omzet Usaha Pemohon", value: pekerjaan.omzetusahapemohon },
          {
            label: "Profit Usaha Pemohon",
            value: pekerjaan.profitusahapemohon,
          },
        ],
        pasangan_pemohon: [
          { label: "Nama Pasangan", value: pasangan.namapasangan },
          { label: "Nama Panggilan", value: pasangan.namapanggilan },
          { label: "No. KTP Pasangan", value: pasangan.ktppasangan },
          { label: "Agama Pasangan", value: pasangan.agamapasangan },
          {
            label: "Jenis Kelamin Pasangan",
            value: jenisKelaminPasangan,
          },
          { label: "Pekerjaan Pasangan", value: pasangan.pekerjaanpasangan },
          {
            label: "Warga Negara Pasangan",
            value: pasangan.warganegarapasangan,
          },
          { label: "No. Telepon Pasangan", value: pasangan.notelppasangan },
          { label: "No. HP Pasangan", value: pasangan.nohppasangan },
        ],
        // ... tetapkan sisa mapping penjamin, pekerjaan_penjamin, dsb
        penjamin: [
          { label: "Jenis Penjamin", value: penjamin.jnspenjamin },
          {
            label: "Status Pernikahan Penjamin",
            value: penjamin.statuspernikahanpenjamin,
          },
          { label: "Nama Penjamin", value: penjamin.namapenjamin },
          { label: "Agama Penjamin", value: penjamin.agamapenjamin },
          { label: "Pekerjaan Penjamin", value: penjamin.pekerjaanpenjamin },
          { label: "Jabatan Penjamin", value: penjamin.jabatanpenjamin },
          {
            label: "Warga Negara Penjamin",
            value: penjamin.warganegarapenjamin,
          },
          { label: "No. Telepon Penjamin", value: penjamin.notelppenjamin },
          { label: "No. WA Penjamin", value: penjamin.nowapenjamin },
          { label: "Email Penjamin", value: penjamin.emailpenjamin },
          { label: "No. KTP Penjamin", value: penjamin.noktppenjamin },
          { label: "Tanggal KTP Penjamin", value: penjamin.tglktppenjamin },
          { label: "NPWP Penjamin", value: penjamin.npwppenjamin },
          { label: "Alamat Penjamin", value: penjamin.alamatpenjamin },
        ],
        kontak_darurat: [
          { label: "Nama Kontak", value: kontak_darurat.namakontak },
          {
            label: "Jenis Kelamin Kontak",
            value: kontak_darurat.jeniskelaminkontak,
          },
          {
            label: "Hubungan Keluarga",
            value: kontak_darurat.hubungankeluarga,
          },
          { label: "No. HP Kontak", value: kontak_darurat.nohpkontak },
          { label: "Kode Pos Kontak", value: kontak_darurat.kodeposkontak },
          { label: "Alamat Kontak", value: kontak_darurat.alamatkontak },
        ],
      };

      const filteredCustomerData = {};
      for (const key in rawCustomerData) {
        const items = rawCustomerData[key];
        const hasValue = items.some(
          (item) =>
            item.value !== null &&
            item.value !== undefined &&
            item.value !== "",
        );
        if (hasValue) filteredCustomerData[key] = items;
      }

      setData([
        { id: 1, name: "Customer Info", data: filteredCustomerData },
        {
          id: 2,
          name: "Photo & Document",
          data: { photoDocument: combinedPhotos },
        },
        { id: 3, name: "Credit Review", data: {} },
        { id: 5, name: "Credit Approval", data: {} },
        { id: 6, name: "SLIK & Calculation", data: {} },
        { id: 7, name: "PEFINDO ", data: {} },
        // TAB BARU: Detail Kendaraan & Perhitungan
        { id: 8, name: "Detail Kendaraan & Perhitungan", data: {} },
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Data gagal diambil dari server.");
    }
  };

  const getFotoTambahan = async () => {
    try {
      const res = await fetch(
        `${
          import.meta.env.VITE_BASE_URL2
        }/api/foto-tambahan/searchby/${application_id}/${nik}`,
      );
      if (!res.ok) throw new Error("Gagal ambil data foto tambahan");

      const data = await res.json();

      let parsed = [];
      if (Array.isArray(data.doctambahanimage)) {
        parsed = data.doctambahanimage;
      } else if (typeof data.doctambahanimage === "string") {
        try {
          parsed = JSON.parse(data.doctambahanimage);
        } catch (e) {
          console.warn(
            "⚠️ doctambahanimage bukan JSON array valid:",
            data.doctambahanimage,
          );
        }
      }

      setFotoTambahanList(parsed || []);
    } catch (err) {
      console.error("Error getFotoTambahan:", err);
      setFotoTambahanList([]);
    }
  };

  const getFotoTambahanNew = async () => {
    try {
      const res = await fetch(
        `${
          import.meta.env.VITE_BASE_URL2
        }/api/foto-tambahan/searchby/${application_id}/${nik}`,
      );
      if (!res.ok) throw new Error("Gagal ambil data foto tambahan baru");

      const data = await res.json();
      console.log("Data doctambahannew:", data);

      setFotoTambahanNewList(data.doctambahannew || []);
      setFotoTambahanPraGolife(data.docverifikasi || []);
    } catch (err) {
      console.error("Error getFotoTambahanNew:", err);
      setFotoTambahanNewList([]);
      setFotoTambahanPraGolife([]);
    }
  };

  useEffect(() => {
    getData();
    getFotoTambahan();
    getFotoTambahanNew();
  }, []);

  const [activeKey, setActiveKey] = useState("1");
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [fotoTambahanList, setFotoTambahanList] = useState([]);
  const [fotoTambahanNewList, setFotoTambahanNewList] = useState([]);
  const [fotoTambahanPraGolife, setFotoTambahanPraGolife] = useState([]);

  // --- State & logika untuk Perhitungan Kredit ---
  // / --- State & logika untuk Perhitungan Kredit ---
  const [jenisAngsur, setJenisAngsur] = useState("Bulanan");
  const [metodeBunga, setMetodeBunga] = useState("Efektif");
  const [harga, setHarga] = useState("");
  const [uangMukaAmount, setUangMukaAmount] = useState("");
  const [uangMukaPercent, setUangMukaPercent] = useState("");
  const [pokokHutang, setPokokHutang] = useState(0);
  const [tenor, setTenor] = useState(""); // dalam tahun
  const [gracePeriod, setGracePeriod] = useState(0); // bulan
  const [bungaFlat, setBungaFlat] = useState(0);
  const [bungaEfektif, setBungaEfektif] = useState(0);
  const [pencairanKeDealer, setPencairanKeDealer] = useState(""); // pencairan yang diterima (mibas)
  const [nilaiAngsuran, setNilaiAngsuran] = useState(0);
  const [tanggalCair, setTanggalCair] = useState(null);
  const [metodeAngsur, setMetodeAngsur] = useState("Flat");
  const [pembayaran, setPembayaran] = useState("");
  const [loading, setLoading] = useState(false);

  const [dendaEnabled, setDendaEnabled] = useState(true); // default yes
  const [rateDenda, setRateDenda] = useState(0.5); // default 0.5%
  const [bungaEnabled, setBungaEnabled] = useState(true); // default yes
  const [penalty, setPenalty] = useState(5); // default 5%
  const [maskapaiAsuransi, setMaskapaiAsuransi] = useState("");

  const [hasilKalkulasi, setHasilKalkulasi] = useState(null);

  useEffect(() => {
    const kendaraanItems = data?.[0]?.data?.kendaraan || [];

    const hargaItem = kendaraanItems?.find(
      (i) => i.label === "Harga Kendaraan",
    );
    const dpItem = kendaraanItems?.find((i) => i.label === "Uang Muka");

    console.log("hargaItem =>", hargaItem);
    console.log("dpItem =>", dpItem);

    const hargaNum = hargaItem?.value
      ? Number(hargaItem.value.replace(/\D/g, ""))
      : 0;

    const dpNum = dpItem?.value ? Number(dpItem.value.replace(/\D/g, "")) : 0;

    if (pokokHutang === "" && hargaNum > 0) {
      const pokok = hargaNum - dpNum;
      setPokokHutang(pokok.toLocaleString("id-ID"));
    }
  }, [data]);

  // useEffect(() => {
  //   const p = parseFloat((harga || "").toString().replace(/,/g, "")) || 0;
  //   const amt = parseFloat((uangMukaAmount || "").toString().replace(/,/g, ""));
  //   const pct = parseFloat((uangMukaPercent || "").toString());

  //   if (!isNaN(amt) && amt >= 0 && p > 0) {
  //     const percent = (amt / p) * 100;
  //     if (!isNaN(percent)) setUangMukaPercent(percent.toFixed(2));
  //     setPokokHutang(Math.max(0, p - (isNaN(amt) ? 0 : amt)));
  //   } else if (!isNaN(pct) && pct >= 0 && p > 0) {
  //     const amount = (pct / 100) * p;
  //     setUangMukaAmount(Math.round(amount));
  //     setPokokHutang(Math.max(0, p - Math.round(amount)));
  //   } else {
  //     setPokokHutang(Math.max(0, p - (isNaN(amt) ? 0 : amt)));
  //   }
  // }, [harga, uangMukaAmount, uangMukaPercent]);

  //  const calculateInstallment = () => {
  //   const p = parseFloat((harga || "").toString().replace(/,/g, "")) || 0;
  //   const dp = parseFloat((uangMukaAmount || "").toString().replace(/,/g, "")) || 0;
  //   const years = parseFloat(tenor) || 0;
  //   const annualRate = metodeBunga === "Flat" ? parseFloat(bungaFlat) || 0 : parseFloat(bungaEfektif) || 0;

  //   const loan = Math.max(0, p - dp);
  //   const n = Math.max(1, Math.round(years * 12)); // jumlah bulan
  //   const r = annualRate / 100 / 12; // monthly rate

  //   let monthly = 0;
  //   if (r === 0) {
  //     monthly = loan / n;
  //   } else {
  //     if (metodeAngsur === "Flat") {
  //       // simple flat calculation (monthly interest on principal / months + principal/months)
  //       const interestTotal = loan * (annualRate / 100) * years;
  //       monthly = (loan + interestTotal) / n;
  //     } else {
  //       // annuity (efektif)
  //       const factor = Math.pow(1 + r, n);
  //       monthly = (loan * r * factor) / (factor - 1);
  //     }
  //   }
  //   const total = monthly * n;

  //   const result = {
  //     loanAmount: loan,
  //     monthly: isFinite(monthly) ? monthly : 0,
  //     total: isFinite(total) ? total : 0,
  //     n,
  //   };
  //   setHasilKalkulasi(result);
  //   setNilaiAngsuran(result.monthly);
  //   message.success("Kalkulasi selesai");
  // };

      console.log("dataPemohon API ==> ", dokumenUrls);


  return (
    <div>
      <h1 className="text-4xl font-semibold mb-8">APPROVAL DETAIL PAGE</h1>
      <div className="p-4 bg-blue-50 border border-blue-100 shadow-sm rounded-xl mb-6">
        <div className="grid grid-cols-2 gap-x-8 gap-y-2">
          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">Application Id</div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              {headerInfo.application_no}
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">Nama Pemohon</div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              {headerInfo.customer_name}
            </div>
          </div>

          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">Survey Date</div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              {headerInfo.application_date}
            </div>
          </div>

          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">Status</div>
            <div className="w-1/2 text-sm font-semibold">
              {(() => {
                const statusLabelMap = {
                  CRA: "Credit Review Analis",
                  "APPV-1": "Approval 1",
                  "APPV-2": "Approval 2",
                  "APPV-3": "APPROVAL 3",
                  FA: "Final Approve",
                };

                const statusRaw = headerInfo?.status || "";
                const statusCleaned = statusRaw?.replace(/\s+/g, "");
                const label = statusLabelMap[statusCleaned] || statusRaw;

                return (
                  <span
                    style={{
                      color: "#0a0a0a",
                      display: "inline-block",
                    }}
                  >
                    {label}
                  </span>
                );
              })()}
            </div>
          </div>

          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">NAMA CABANG</div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              {headerInfo.branch_name}
            </div>
          </div>
          <div className="flex">
            <div className="w-1/2 text-sm text-gray-600">CMO </div>
            <div className="w-1/2 text-sm font-semibold text-gray-800">
              {headerInfo.cmo}
            </div>
          </div>
        </div>
      </div>

      <Tabs
        onChange={(key) => setActiveKey(key)}
        activeKey={activeKey}
        type="card"
        size="small"
        items={data.map((section, index) => {
          const tabId = String(index + 1);
          return {
            label: <span>{section.name}</span>,
            key: tabId,
            children: (
              <div>
                {section.id === 1 ? (
                  <Collapse
                    ghost
                    defaultActiveKey={Object.entries(section.data).map(
                      ([, _], index) => String(index),
                    )}
                  >
                    {Object.entries(section.data).map(
                      ([panelKey, items], index) => {
                        const isNotEmpty = items.some(
                          (item) =>
                            item.value !== null &&
                            item.value !== undefined &&
                            item.value !== "",
                        );
                        if (!isNotEmpty) return null;

                        const titleMap = {
                          dealer: "Dealer",
                          kendaraan: "Kendaraan",
                          customer: "Pemohon",
                          pekerjaan_pemohon: "Pekerjaan / Usaha Pemohon",
                          pasangan_pemohon: "Pasangan Pemohon",
                          pekerjaan_pasangan: "Pekerjaan / Usaha Pasangan",
                          penjamin: "Penjamin",
                          pekerjaan_penjamin: "Pekerjaan / Usaha Penjamin",
                          pasangan_penjamin: "Pasangan Penjamin",
                          pekerjaan_pasangan_penjamin:
                            "Pekerjaan / Usaha Pasangan Penjamin",
                          kontak_darurat: "Kontak Darurat",
                        };

                        return (
                          <Panel
                            header={titleMap[panelKey] || panelKey}
                            key={index}
                          >
                            <div className="p-4 bg-gray-50 border border-gray-200 shadow-sm rounded-xl mb-6">
                              <div className="grid grid-cols-2 gap-x-8 gap-y-3">
                                {items.map((item, idx) => (
                                  <div key={idx} className="flex">
                                    <div className="w-1/2 text-sm text-gray-600">
                                      {item.label}
                                    </div>
                                    <div className="w-1/2 text-sm font-semibold text-gray-800">
                                      {item.value || "-"}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </Panel>
                        );
                      },
                    )}
                  </Collapse>
                ) : section.id === 2 ? (
                  <Collapse
                    ghost
                    defaultActiveKey={section.data.photoDocument?.map((_, i) =>
                      String(i),
                    )}
                  >
                    {section.data.photoDocument?.map((panelData, i) => (
                      <Panel header={panelData.panel} key={i}>
                        <div className="p-4">
                          <ThumbnailGrid
                            items={panelData.items}
                            albumKey={panelData.items?.[0]?.typeUpload}
                            application_id={application_id}
                            nik={nik}
                            onUpload={async (file, albumKey) => {
                              try {
                                const formData = new FormData();
                                formData.append(albumKey, file);
                                formData.append(
                                  "application_id",
                                  application_id,
                                );
                                formData.append("nik", nik);
                                formData.append("created_by", "system");

                                const res = await fetch(
                                  `${
                                    import.meta.env.VITE_BASE_URL2
                                  }/api/foto-tambahan/upload`,
                                  {
                                    method: "POST",
                                    body: formData,
                                  },
                                );

                                const text = await res.text();
                                console.log("Upload response:", text);

                                if (!res.ok)
                                  throw new Error(
                                    `Upload gagal: ${res.status} ${text}`,
                                  );

                                message.success("Upload berhasil!");
                                getData();
                              } catch (err) {
                                console.error(err);
                                message.error("Upload gagal.");
                              }
                            }}
                          />
                        </div>
                      </Panel>
                    ))}

                    {!isViewer && 
                     <>
                      <Panel
                        header="Foto dan Dokumen Tambahan (Setelah Submit Survey)"
                        key="upload-tambahan"
                      >
                        <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl shadow-sm flex flex-col gap-6">
                          <div className="flex flex-col gap-3">
                            <input
                              id="uploadTambahanInput"
                              type="file"
                              multiple
                              accept=".pdf,image/jpeg,image/png,image/jpg"
                              onChange={(e) => setSelectedFiles(e.target.files)}
                              className="block border border-gray-300 rounded-md p-2"
                            />
                            <button
                              onClick={async () => {
                                if (
                                  !selectedFiles ||
                                  selectedFiles.length === 0
                                ) {
                                  message.warning(
                                    "Pilih minimal satu file sebelum upload.",
                                  );
                                  return;
                                }

                                const formData = new FormData();
                                formData.append("application_id", application_id);
                                formData.append("nik", nik);
                                formData.append("created_by", "system");
                                formData.append("target_field", "doctambahannew");

                                for (let i = 0; i < selectedFiles.length; i++) {
                                  formData.append(
                                    "doctambahannew",
                                    selectedFiles[i],
                                  );
                                }

                                try {
                                  const res = await fetch(
                                    `${
                                      import.meta.env.VITE_BASE_URL2
                                    }/api/foto-tambahan/upload-los`,
                                    {
                                      method: "POST",
                                      body: formData,
                                    },
                                  );

                                  const text = await res.text();
                                  console.log("Upload response:", text);

                                  if (!res.ok)
                                    throw new Error(
                                      `Upload gagal: ${res.status} ${text}`,
                                    );

                                  message.success("Upload berhasil!");
                                  setSelectedFiles(null);
                                  document.getElementById(
                                    "uploadTambahanInput",
                                  ).value = "";
                                  await getFotoTambahanNew();
                                } catch (err) {
                                  console.error(err);
                                  message.error("Upload gagal. Coba lagi.");
                                }
                              }}
                              disabled={isViewer}
                              className={`px-4 py-2 rounded-lg w-fit text-white ${isViewer ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
                            >
                              Upload File
                            </button>
                            <p className="text-sm text-gray-600">
                              Format diizinkan: <b>PDF, JPG, JPEG, PNG</b> &nbsp;
                              • &nbsp; Bisa pilih lebih dari satu file
                            </p>
                          </div>

                          <div>
                            <h3 className="text-base font-semibold mb-3">
                              Dokumen Tambahan Baru:
                            </h3>
                            {fotoTambahanNewList.length === 0 ? (
                              <p className="text-gray-500 text-sm">
                                Belum ada dokumen tambahan baru.
                              </p>
                            ) : (
                              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                {fotoTambahanNewList.map((url, idx) => (
                                  <div
                                    key={idx}
                                    className="border rounded-lg overflow-hidden shadow-sm bg-white hover:shadow-md transition"
                                  >
                                    {url.endsWith(".pdf") ? (
                                      <div className="p-2 flex flex-col items-center text-center">
                                        <span className="text-sm font-medium text-gray-700 truncate w-full">
                                          {url.split("/").pop()}
                                        </span>
                                        <a
                                          href={url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="mt-2 text-blue-600 hover:underline text-sm"
                                        >
                                          Lihat PDF
                                        </a>
                                      </div>
                                    ) : (
                                      <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          src={url}
                                          alt={`Dokumen ${idx + 1}`}
                                          className="object-cover w-full h-40"
                                        />
                                      </a>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </Panel>
                      <Panel
                        header="Foto dan Dokumen Verifikasi Pra Golife"
                        key="upload-tambahan2"
                      >
                        <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl shadow-sm flex flex-col gap-6">
                          <div className="flex flex-col gap-3">
                            <input
                              id="uploadTambahanInput2"
                              type="file"
                              multiple
                              accept=".pdf,image/jpeg,image/png,image/jpg"
                              onChange={(e) => setSelectedFiles(e.target.files)}
                              className="block border border-gray-300 rounded-md p-2"
                            />
                            <button
                              onClick={async () => {
                                if (
                                  !selectedFiles ||
                                  selectedFiles.length === 0
                                ) {
                                  message.warning(
                                    "Pilih minimal satu file sebelum upload.",
                                  );
                                  return;
                                }

                                const formData = new FormData();
                                formData.append("application_id", application_id);
                                formData.append("nik", nik);
                                formData.append("created_by", "system");
                                formData.append("target_field", "docverifikasi");

                                for (let i = 0; i < selectedFiles.length; i++) {
                                  formData.append(
                                    "docverifikasi",
                                    selectedFiles[i],
                                  );
                                }

                                try {
                                  const res = await fetch(
                                    `${
                                      import.meta.env.VITE_BASE_URL2
                                    }/api/foto-tambahan/upload-verifikasi-pragolife`,
                                    {
                                      method: "POST",
                                      body: formData,
                                    },
                                  );

                                  const text = await res.text();
                                  console.log("Upload response:", text);

                                  if (!res.ok)
                                    throw new Error(
                                      `Upload gagal: ${res.status} ${text}`,
                                    );

                                  message.success("Upload berhasil!");
                                  setSelectedFiles(null);
                                  document.getElementById(
                                    "uploadTambahanInput2",
                                  ).value = "";
                                  await getFotoTambahanNew();
                                } catch (err) {
                                  console.error(err);
                                  message.error("Upload gagal. Coba lagi.");
                                }
                              }}
                              disabled={isViewer}
                              className={`px-4 py-2 rounded-lg w-fit text-white ${isViewer ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
                            >
                              Upload File
                            </button>
                            <p className="text-sm text-gray-600">
                              Format diizinkan: <b>PDF, JPG, JPEG, PNG</b> &nbsp;
                              • &nbsp; Bisa pilih lebih dari satu file
                            </p>
                          </div>

                          <div>
                            <h3 className="text-base font-semibold mb-3">
                              Dokumen Tambahan Baru (Pra Golife):
                            </h3>
                            {fotoTambahanPraGolife.length === 0 ? (
                              <p className="text-gray-500 text-sm">
                                Belum ada dokumen tambahan baru (Pra Golife).
                              </p>
                            ) : (
                              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                                {fotoTambahanPraGolife.map((url, idx) => (
                                  <div
                                    key={idx}
                                    className="border rounded-lg overflow-hidden shadow-sm bg-white hover:shadow-md transition"
                                  >
                                    {url.endsWith(".pdf") ? (
                                      <div className="p-2 flex flex-col items-center text-center">
                                        <span className="text-sm font-medium text-gray-700 truncate w-full">
                                          {url.split("/").pop()}
                                        </span>
                                        <a
                                          href={url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="mt-2 text-blue-600 hover:underline text-sm"
                                        >
                                          Lihat PDF
                                        </a>
                                      </div>
                                    ) : (
                                      <a
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          src={url}
                                          alt={`Dokumen ${idx + 1}`}
                                          className="object-cover w-full h-40"
                                        />
                                      </a>
                                    )}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </Panel>
                     </>
                    }
                  </Collapse>
                ) : section.id === 3 ? (
                  <CreditReviewForm pemohonData={pemohonData} />
                ) : section.id === 5 ? (
                  <Approvalform />
                ) : section.id === 6 ? (
                  // <Collapse ghost defaultActiveKey={["1", "2"]}>
                  //   {/* ... SLIK panels (tidak diubah) */}
                  //   <Panel header="Hasil SLIK Pemohon & Pasangan (PDF)" key="1">
                  //     <Collapse
                  //       ghost
                  //       defaultActiveKey={[
                  //         "summarypemohon",
                  //         "summarypasangan",
                  //         "pemohon",
                  //         "pasangan",
                  //       ]}
                  //     >
                  //       <Panel
                  //         header="SUMMARY SLIK Pemohon"
                  //         key="summarypemohon"
                  //       >
                  //         <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                  //           <p className="mb-2">
                  //             File PDF Summary SLIK Pemohon:
                  //           </p>
                  //           <iframe
                  //             src={`${API_BASE_URL}/uploads/HasilSLIK/${application_id}/${nik}/summary_${nik}.pdf`}
                  //             width="100%"
                  //             height="700px"
                  //             style={{
                  //               border: "1px solid #ccc",
                  //               borderRadius: "8px",
                  //             }}
                  //             title="Summary SLIK PDF Pemohon"
                  //           />
                  //         </div>
                  //       </Panel>

                  //       {nikPasangan && (
                  //         <Panel
                  //           header="SUMMARY SLIK Pasangan"
                  //           key="summarypasangan"
                  //         >
                  //           <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                  //             <p className="mb-2">
                  //               File PDF Summary SLIK Pasangan:
                  //             </p>
                  //             <iframe
                  //               src={`${API_BASE_URL}/uploads/HasilSLIK/${application_id}/${nikPasangan}/summary_${nikPasangan}.pdf`}
                  //               width="100%"
                  //               height="700px"
                  //               style={{
                  //                 border: "1px solid #ccc",
                  //                 borderRadius: "8px",
                  //               }}
                  //               title="Summary SLIK PDF Pasangan"
                  //             />
                  //           </div>
                  //         </Panel>
                  //       )}

                  //       <Panel header="SLIK Pemohon" key="pemohon">
                  //         <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                  //           <p className="mb-2">File PDF hasil SLIK Pemohon:</p>
                  //           <iframe
                  //             src={`${API_BASE_URL}/uploads/HasilSLIK/${application_id}/${nik}/${nik}.pdf`}
                  //             width="100%"
                  //             height="700px"
                  //             style={{
                  //               border: "1px solid #ccc",
                  //               borderRadius: "8px",
                  //             }}
                  //             title="SLIK PDF Pemohon"
                  //           />
                  //         </div>
                  //       </Panel>

                  //       {nikPasangan && (
                  //         <Panel header="SLIK Pasangan" key="pasangan">
                  //           <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                  //             <p className="mb-2">
                  //               File PDF hasil SLIK Pasangan:
                  //             </p>
                  //             <iframe
                  //               src={`${API_BASE_URL}/uploads/HasilSLIK/${application_id}/${nikPasangan}/${nikPasangan}.pdf`}
                  //               width="100%"
                  //               height="700px"
                  //               style={{
                  //                 border: "1px solid #ccc",
                  //                 borderRadius: "8px",
                  //               }}
                  //               title="SLIK PDF Pasangan"
                  //             />
                  //           </div>
                  //         </Panel>
                  //       )}
                  //     </Collapse>
                  //   </Panel>
                  // </Collapse>
                  <Collapse ghost defaultActiveKey={["1", "2"]}>
                    <Panel header="Hasil SLIK Pemohon & Pasangan (PDF)" key="1">
                      <Collapse
                        ghost
                        defaultActiveKey={[
                          "summarypemohon",
                          "summarypasangan",
                          "pemohon",
                          "pasangan",
                        ]}
                      >
                        <Panel header="SUMMARY SLIK Pemohon" key="summarypemohon">
                          <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                            <p className="mb-2">File PDF Summary SLIK Pemohon:</p>
                            
                            {/* Cek apakah nilai summary_slik tidak null di database */}
                            {dokumenUrls.summary_slik ? (
                              <iframe
                                // src={`${API_BASE_URL}/uploads/HasilSLIK/${application_id}/${nik}/summary_${nik}.pdf`}
                                src={dokumenUrls.summary_slik}
                                width="100%"
                                height="700px"
                                style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                                title="Summary SLIK PDF Pemohon"
                              />
                            ) : (
                              <div className="flex flex-col items-center justify-center h-[300px] bg-gray-100 border border-dashed border-gray-300 rounded-lg text-gray-500">
                                <span className="font-semibold text-lg">Dokumen Tidak Tersedia</span>
                                {/* <span className="text-sm">File telah dihapus dari sistem (Status Final).</span> */}
                              </div>
                            )}
                          </div>
                        </Panel>

                        {nikPasangan && (
                          <Panel header="SUMMARY SLIK Pasangan" key="summarypasangan">
                            <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                              <p className="mb-2">File PDF Summary SLIK Pasangan:</p>
                              
                              {/* Cek apakah nilai summary_slik_pasangan tidak null */}
                              {dokumenUrls.summary_slik_pasangan ? (
                                <iframe
                                  // src={`${API_BASE_URL}/uploads/HasilSLIK/${application_id}/${nikPasangan}/summary_${nikPasangan}.pdf`}
                                  src={dokumenUrls.summary_slik_pasangan}
                                  width="100%"
                                  height="700px"
                                  style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                                  title="Summary SLIK PDF Pasangan"
                                />
                              ) : (
                                <div className="flex flex-col items-center justify-center h-[300px] bg-gray-100 border border-dashed border-gray-300 rounded-lg text-gray-500">
                                  <span className="font-semibold text-lg">Dokumen Tidak Tersedia</span>
                                  {/* <span className="text-sm">File telah dihapus dari sistem (Status Final).</span> */}
                                </div>
                              )}
                            </div>
                          </Panel>
                        )}

                        <Panel header="SLIK Pemohon" key="pemohon">
                          <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                            <p className="mb-2">File PDF hasil SLIK Pemohon:</p>
                            
                            {/* Cek apakah nilai uri_slik tidak null */}
                            {dokumenUrls.uri_slik ? (
                              <iframe
                                // src={`${API_BASE_URL}/uploads/HasilSLIK/${application_id}/${nik}/${nik}.pdf`}
                                src={dokumenUrls.uri_slik}
                                width="100%"
                                height="700px"
                                style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                                title="SLIK PDF Pemohon"
                              />
                            ) : (
                              <div className="flex flex-col items-center justify-center h-[300px] bg-gray-100 border border-dashed border-gray-300 rounded-lg text-gray-500">
                                <span className="font-semibold text-lg">Dokumen Tidak Tersedia</span>
                                <span className="text-sm">File telah dihapus dari sistem (Status Final).</span>
                              </div>
                            )}
                          </div>
                        </Panel>

                        {nikPasangan && (
                          <Panel header="SLIK Pasangan" key="pasangan">
                            <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                              <p className="mb-2">File PDF hasil SLIK Pasangan:</p>
                              
                              {/* Cek apakah nilai uri_slik_pasangan tidak null */}
                              {dokumenUrls.uri_slik_pasangan ? (
                                <iframe
                                  // src={`${API_BASE_URL}/uploads/HasilSLIK/${application_id}/${nikPasangan}/${nikPasangan}.pdf`}
                                  src={dokumenUrls.uri_slik_pasangan}
                                  width="100%"
                                  height="700px"
                                  style={{ border: "1px solid #ccc", borderRadius: "8px" }}
                                  title="SLIK PDF Pasangan"
                                />
                              ) : (
                                <div className="flex flex-col items-center justify-center h-[300px] bg-gray-100 border border-dashed border-gray-300 rounded-lg text-gray-500">
                                  <span className="font-semibold text-lg">Dokumen Tidak Tersedia</span>
                                  <span className="text-sm">File telah dihapus dari sistem (Status Final).</span>
                                </div>
                              )}
                            </div>
                          </Panel>
                        )}
                      </Collapse>
                    </Panel>
                  </Collapse>
                ) : section.id === 7 ? (
                  // <Collapse ghost defaultActiveKey={["1", "2"]}>
                  //   {/* PEFINDO panels (tetap) */}
                  //   <Panel
                  //     header="Hasil PEFINDO Pemohon & Pasangan (PDF)"
                  //     key="1"
                  //   >
                  //     <Collapse
                  //       ghost
                  //       defaultActiveKey={["pemohon", "pasangan"]}
                  //     >
                  //       <Panel header="PEFINDO Pemohon" key="pemohon">
                  //         <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                  //           <p className="mb-2">
                  //             File PDF hasil Pefindo Pemohon:
                  //           </p>
                  //           <iframe
                  //             src={`${API_BASE_URL}/uploads/HasilPefindo/${application_id}/${nik}/${nik}.pdf`}
                  //             width="100%"
                  //             height="700px"
                  //             style={{
                  //               border: "1px solid #ccc",
                  //               borderRadius: "8px",
                  //             }}
                  //             title="PEFINDO PDF Pemohon"
                  //           />
                  //         </div>
                  //       </Panel>

                  //       {nikPasangan && (
                  //         <Panel header="PEFINDO Pasangan" key="pasangan">
                  //           <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                  //             <p className="mb-2">
                  //               File PDF hasil Pefindo Pasangan:
                  //             </p>
                  //             <iframe
                  //               src={`${API_BASE_URL}/uploads/HasilPefindo/${application_id}/${nikPasangan}/${nikPasangan}.pdf`}
                  //               width="100%"
                  //               height="700px"
                  //               style={{
                  //                 border: "1px solid #ccc",
                  //                 borderRadius: "8px",
                  //               }}
                  //               title="PEFINDO PDF Pasangan"
                  //             />
                  //           </div>
                  //         </Panel>
                  //       )}
                  //     </Collapse>
                  //   </Panel>
                  // </Collapse>
                  <Collapse ghost defaultActiveKey={["1", "2"]}>
                    <Panel header="Hasil PEFINDO Pemohon & Pasangan (PDF)" key="1">
                      <Collapse ghost defaultActiveKey={["pemohon", "pasangan"]}>
                        <Panel header="PEFINDO Pemohon" key="pemohon">
                          <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                            <p className="mb-2">File PDF hasil Pefindo Pemohon:</p>
                            
                            {/* Cek apakah nilai uri_pefindo tidak null */}
                            {dokumenUrls.uri_pefindo ? (
                              <iframe
                                src={dokumenUrls.uri_pefindo}
                                width="100%"
                                height="700px"
                                style={{
                                  border: "1px solid #ccc",
                                  borderRadius: "8px",
                                }}
                                title="PEFINDO PDF Pemohon"
                              />
                            ) : (
                              <div className="flex flex-col items-center justify-center h-[300px] bg-gray-100 border border-dashed border-gray-300 rounded-lg text-gray-500">
                                <span className="font-semibold text-lg">Dokumen Tidak Tersedia</span>
                                <span className="text-sm">File telah dihapus dari sistem (Status Final).</span>
                              </div>
                            )}
                          </div>
                        </Panel>

                        {nikPasangan && (
                          <Panel header="PEFINDO Pasangan" key="pasangan">
                            <div className="p-4 bg-gray-50 rounded-xl border border-gray-200">
                              <p className="mb-2">File PDF hasil Pefindo Pasangan:</p>
                              
                              {/* Cek apakah nilai uri_pefindo_pasangan tidak null */}
                              {dokumenUrls.uri_pefindo_pasangan ? (
                                <iframe
                                  // src={`${API_BASE_URL}/uploads/HasilPefindo/${application_id}/${nikPasangan}/${nikPasangan}.pdf`}
                                  src={dokumenUrls.uri_pefindo_pasangan}
                                  width="100%"
                                  height="700px"
                                  style={{
                                    border: "1px solid #ccc",
                                    borderRadius: "8px",
                                  }}
                                  title="PEFINDO PDF Pasangan"
                                />
                              ) : (
                                <div className="flex flex-col items-center justify-center h-[300px] bg-gray-100 border border-dashed border-gray-300 rounded-lg text-gray-500">
                                  <span className="font-semibold text-lg">Dokumen Tidak Tersedia</span>
                                  <span className="text-sm">File telah dihapus dari sistem (Status Final).</span>
                                </div>
                              )}
                            </div>
                          </Panel>
                        )}
                      </Collapse>
                    </Panel>
                  </Collapse>
                ) : section.id === 8 ? (
                  <div className="p-4">
                    <Collapse
                      ghost
                      defaultActiveKey={["detail", "perhitungan"]}
                    >
                      {/* ===== DETAIL KENDARAAN ===== */}
                      <Panel header="Detail Kendaraan" key="detail">
                        <div className="p-4 bg-gray-50 border border-gray-200 rounded-xl">
                          <DetailKendaraan
                            data={data}
                            application_id={application_id}
                            harga={harga}
                            setHarga={setHarga}
                            uangMukaAmount={uangMukaAmount}
                            setUangMukaAmount={setUangMukaAmount}
                            getData={getData}
                            onSave={(updatedItems) => {
                              console.log("Data kendaraan baru:", updatedItems);
                              // panggil API update di sini
                            }}
                          />
                        </div>
                      </Panel>

                      {/* ===== INPUT PERHITUNGAN KREDIT ===== */}
                      <Panel
                        header="Input Perhitungan Kredit (Manual Input)"
                        key="perhitungan"
                      >
                        <InputPerhitunganKredit
                          data={data}
                          application_id={application_id}
                          nik={nik}
                          jenisAngsur={jenisAngsur}
                          setJenisAngsur={setJenisAngsur}
                          metodeBunga={metodeBunga}
                          setMetodeBunga={setMetodeBunga}
                          maskapaiAsuransi={maskapaiAsuransi}
                          setMaskapaiAsuransi={setMaskapaiAsuransi}
                          harga={harga}
                          setHarga={setHarga}
                          uangMukaAmount={uangMukaAmount}
                          setUangMukaAmount={setUangMukaAmount}
                          uangMukaPercent={uangMukaPercent}
                          setUangMukaPercent={setUangMukaPercent}
                          pokokHutang={pokokHutang}
                          setPokokHutang={setPokokHutang}
                          tenor={tenor}
                          setTenor={setTenor}
                          gracePeriod={gracePeriod}
                          setGracePeriod={setGracePeriod}
                          bungaFlat={bungaFlat}
                          setBungaFlat={setBungaFlat}
                          bungaEfektif={bungaEfektif}
                          setBungaEfektif={setBungaEfektif}
                          nilaiAngsuran={nilaiAngsuran}
                          setNilaiAngsuran={setNilaiAngsuran}
                          pencairanKeDealer={pencairanKeDealer}
                          setPencairanKeDealer={setPencairanKeDealer}
                          tanggalCair={tanggalCair}
                          setTanggalCair={setTanggalCair}
                          metodeAngsur={metodeAngsur}
                          setMetodeAngsur={setMetodeAngsur}
                          pembayaran={pembayaran}
                          setPembayaran={setPembayaran}
                          rateDenda={rateDenda}
                          setRateDenda={setRateDenda}
                          penalty={penalty}
                          setPenalty={setPenalty}
                          loading={loading}
                          setLoading={setLoading}
                          onSaveSuccess={getData}
                        />
                      </Panel>
                    </Collapse>
                  </div>
                ) : null}
              </div>
            ),
          };
        })}
      />
    </div>
  );
};

export default ApprovalDetailPage;
